<template>
  <v-app id="inspire">
    <alert-modal v-if="getIsInAlert()"></alert-modal>
    <v-content class="login">
      <v-layout row wrap fill-height>
        <v-flex
          xs12 lg6
          class="login_content"
        >
          <img src="@/assets/img/elipse.png" class="login_content__elipse" />
          <div class="login_content__ctelipse"></div>
          <v-layout class="login_content__logo">
            <img src="@/assets/img/logo.png" class="login_content__logo--logo" />
          </v-layout>
          <v-layout
            class="login_content__form"
            column
            :style="{'background-image': 'url(' + require('../../assets/img/f-marca-agua.png') + ')'}"
          >
            <p class="login_content__form--title">Iniciar sesión</p>
                <form v-if="!isDesktopApp" class="content_form" @submit.prevent="trySignIn">
                  <div class="content_form__field">
                    <p class="content_form__label">Correo electrónico</p>
                    <input
                      type="text"
                      class="content_form__input"
                      placeholder="Escribe tu correo de acceso"
                      v-model="user.email"
                      :class="{'error_input': emailError}"
                      @blur="touched.email = true"
                    >
                    <span class="content_form__error">{{ emailError }}</span>
                  </div>

                  <div class="content_form__field">
                    <p class="content_form__label">Contraseña</p>
                    <div class="content_form__password">
                      <input
                        :type="showPassword ? 'text' : 'password'"
                        class="content_form__input"
                        placeholder="Escribe tu contraseña"
                        v-model="user.password"
                        :class="{'error_input': passError}"
                        @blur="touched.password = true"
                      >
                      <button
                        type="button"
                        class="content_form__toggle"
                        @click="showPassword = !showPassword"
                      >
                        <i class="material-icons">{{ showPassword ? 'visibility_off' : 'visibility' }}</i>
                      </button>
                    </div>
                    <span class="content_form__error">{{ passError }}</span>
                  </div>

                  <button
                    type="submit"
                    class="content_form__button"
                    :disabled="loading"
                  >
                    <span v-if="loading" class="content_form__spinner"></span>
                    <span v-else>Ingresar</span>
                  </button>
                </form>
                <div v-else >
                  <div class="content_form__radio">
                    <input
                    type="radio"
                    class="content_form__radio--input"
                    v-model="counter"
                    value="counterAccess"
                    name="counterAccess"
                    id="counterAccess"
                    :class="{'error_input': error_email !== '' && user.email === ''}"
                    >
                    <label for="counterAccess" class="content_form__radio--label">
                      Counter acceso
                    </label>
                  </div>
                  <div v-if="counter=='counterAccess'">
                    <div class="content_form__counter" >
                       <p
                          class="content_form__label"
                          :class="{'error_text': error_email !== '' && user.email === ''}"
                        >
                          Correo electrónico
                        </p>
                        <input
                          type="text"
                          class="content_form__input"
                          placeholder="Escribe tu correo de acceso"
                          v-model="user.email"
                          :class="{'error_input': error_email !== '' && user.email === ''}"
                        >
                      <p
                        class="content_form__label"
                        :class="{'error_text': error_pass !== '' && user.password === ''}"
                      >
                        Contraseña
                      </p>
                      <input
                        type="password"
                        class="content_form__input"
                        placeholder="Escribe tu contraseña"
                        v-model="user.password"
                        :class="{'error_input': error_pass !== '' && user.password === ''}"
                      >
                    </div>
                    <h5
                      v-if="loadingMessage.length>0"
                      style="margin-left:20px;color:#2196f3;font-size:16px;position:relative;"
                    ><i>{{loadingMessage}}</i></h5>
                    <v-spacer></v-spacer>
                  </div>
                  <div class="content_form__radio">
                    <input
                    type="radio"
                    class="content_form__radio--input"
                    v-model="counter"
                    value="counterOffline"
                    name="counterOffline"
                    id="counterOffline"
                    :class="{'error_input': error_email !== '' && user.email === ''}"
                    >
                    <label for="counterOffline" class="content_form__radio--label">
                      Counter offline
                    </label>
                  </div>
                  <div v-if="counter=='counterOffline'">
                    <div class="content_form__counter" >
                      <p
                        class="content_form__label"
                        :class="{'error_text': error_email !== '' && user.email === ''}"
                      >
                        Correo electrónico
                      </p>
                      <input
                        type="text"
                        class="content_form__input"
                        placeholder="Escribe tu correo de acceso"
                        v-model="user.email"
                        :class="{'error_input': error_email !== '' && user.email === ''}"
                      >
                      <p
                        class="content_form__label"
                        :class="{'error_text': error_pass !== '' && user.password === ''}"
                      >
                        Contraseña
                      </p>
                      <input
                        type="password"
                        class="content_form__input"
                        placeholder="Escribe tu contraseña"
                        v-model="user.password"
                        :class="{'error_input': error_pass !== '' && user.password === ''}"
                      >
                    </div>
                    <h5
                      v-if="loadingMessage.length>0"
                      style="margin-left:20px;color:#2196f3;font-size:16px;position:relative;"
                    ><i>{{loadingMessage}}</i></h5>
                    <v-spacer></v-spacer>
                  </div>
                  <div class="content_form__radio">
                    <input
                    type="radio"
                    class="content_form__radio--input"
                    v-model="counter"
                    value="counterImpresion"
                    name="counterImpresion"
                    id="counterImpresion"
                    :class="{'error_input': error_email !== '' && user.email === ''}"
                    >
                    <label for="counterImpresion" class="content_form__radio--label">
                      Counter Impresion
                    </label>
                  </div>
                  <div v-if="counter=='counterImpresion'">
                    <div class="content_form__counter" >
                       <p
                          class="content_form__label"
                          :class="{'error_text': error_email !== '' && user.email === ''}"
                        >
                          Ip del counter offline
                        </p>
                        <input
                          type="text"
                          class="content_form__input"
                          placeholder="Escribe la ip del counter principal"
                          v-model="ipCounterTaquilla"
                          :class="{'error_input': error_email !== '' && user.email!== ''&& ipCounterTaquilla===''}"
                        >
                        <p
                          class="content_form__label"
                          :class="{'error_text': error_email !== '' && user.email === ''}"
                        >
                          Correo electrónico
                        </p>
                        <input
                          type="text"
                          class="content_form__input"
                          placeholder="Escribe tu correo de acceso"
                          v-model="user.email"
                          :class="{'error_input': error_email !== '' && user.email === ''}"
                        >
                        <p
                          class="content_form__label"
                          :class="{'error_text': error_pass !== '' && user.password === ''}"
                        >
                          Contraseña
                        </p>
                        <input
                          type="password"
                          class="content_form__input"
                          placeholder="Escribe tu contraseña"
                          v-model="user.password"
                          :class="{'error_input': error_pass !== '' && user.password === ''}"
                        >

                    </div>
                    <h5
                      v-if="loadingMessage.length>0"
                      style="margin-left:20px;color:#2196f3;font-size:16px;position:relative;"
                    ><i>{{loadingMessage}}</i></h5>
                    <v-spacer></v-spacer>
                  </div>

                </div>
                <button
                  v-if="isDesktopApp && counter"
                  class="content_form__button"
                  :disabled="loading"
                  @click="trySignIn"
                >
                  <span v-if="loading" class="content_form__spinner"></span>
                  <span v-else>Ingresar</span>
                </button>

                <div class="content_form__footer">
                  <span class="content_form__copy">2020 Fusepong. Todos los derechos reservados.</span>
                  <span class="content_form__version">v {{ appVersion }}</span>
                </div>


            </v-layout>
          </v-flex>
        <v-flex xs12 lg6
          :style="{'background-image': 'url(' + require('../../assets/img/fondo-login.png') + ')', 'background-position': 'center center', 'background-size': 'cover'}"
        >
        </v-flex>
      </v-layout>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    data: () => ({
      drawer: true,
      user:{
        email: '',
        password: ''
      },
      counter:"",
      ipCounterTaquilla:"",
      error_email: '',
      error_pass: '',
      sublocations:'',
      colors:'',
      users:{
        "1015417203":{name:"Wilson Montoya",category:"One", access_doors:[1,2,3]},
        "90020854269":{name:"Andres Fonseca",category:"Premium",access_doors:[5,6,7,8]}
      },
      loadingMessage:'',
      isOnLine:true,
      showPassword: false,
      loading: false,
      touched: { email: false, password: false }
    }),
    props: {
      source: String
    },
    computed:{
      isDesktopApp(){
        return navigator.userAgent=="Comfamiliar-Gimnasios-Desktop-App" || navigator.userAgent=="FusepogSolutionsBookingOffice" || window.eel
      },
      appVersion(){
        return process.env.APP_VERSION || 'dev'
      }
    },
    methods:{
      test_conection(){
        try {
          this.$http.get("app/users/available_users", {
            params:{
              data:this.users
            },
            headers:
              {
                "X-Device-ID" : this.getDeviceId(),
                "Authenticate-token" : "SF-a083c01eacf962b3cdb6"
              }
            }).then(function(response){
            console.log(response);
          }, function(response){
            alert("error")
          })
        } catch (e) {
          alert(e)
        }
      },
      verifyLoadedData(){
        try {
          var self=this;
          if(!window.process){
            return false
          }
          return new Promise(function(resolve, reject) {
          if(self.isDesktopApp){
            var fs=window.require("fs")
            if (!fs) {
              reject('The File APIs are not fully supported in this browser.');
            }
            var filePath= localStorage.getItem("fingerprint_API_env")
            if(!filePath){
              filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
            }
            var myAns=false
            fs.readdir(filePath, function (err, files) {
              //handling error
              if (err) {
                console.log('Unable to scan directory: ' + err);
                reject(err)
              }
              if(files.length==8||files.length==9){
                var verificationArray=["App_Status","Enrollment_Control","Enrollment_Status","Name_FPT","Name_to_match","Verification_Control","Verification_Status","Fingerpr","Counter_Ba"]
                var count=0
                files.forEach(function (file) {
                  if(verificationArray.includes(file.substring(0,file.length-4))){
                      count++;
                  }
                });
                if(files.length==count){
                  localStorage.setItem("fingerprint_API_env",filePath)
                  myAns=true
                }
              }
              resolve(myAns)
            });

          }else{resolve(null)}
        });
        } catch (error) {
          return false;
        }

      },
    trySignIn(){
        if(this.loading) return
        if(this.isOnLine || this.counter=='counterImpresion') this.signIn()
        else this.offlineSignIn()
      },
    async signIn(){
        var self = this;
        try{
          if(!this.isDesktopApp){
            this.touched.email = true
            this.touched.password = true
            if(this.emailError || this.passError) return
          }
          if(this.loading) return
          if(this.counter!="counterImpresion"){
            if(this.user.email != "" && this.user.password != ""){
              this.loading = true
              this.buildDeviceId();
              var payload = {attributes: this.user}
              this.$http.post("users/sign_in", {
                data: this.encrypt(payload).toString()
              },{
                headers:{
                  "X-Device-ID" : this.getDeviceId()
                }
              }).then( async function(response){
               self.loading = false
               await this.loadCompany(response.body.data.attributes.company, response.body.data.attributes.email).then(
                function(value) {
                  console.log('compañia cargada')
                },
                function(error) {
                  console.log('error al cargar compañia')
                 }
              );

              this.updateSessionCompanyId(response.body.data.attributes.company)

              if(response.body.meta.authentication_token != undefined &&
                response.body.meta.authentication_token != null &&
                response.body.meta.authentication_token != ''){
                  if(response.body.meta.uuid != undefined &&
                    response.body.meta.uuid != null){
                    this.updateUserIdEncrypt(response.body.meta.uuid);
                  }
                  self.updateUserRoles(response.body.data.attributes.user_roles)
                  if(response.body.data.attributes.user_info_type=="admin"){


                        self.updateUserToken(response.body.meta.authentication_token)
                        self.updateUserId(response.body.data.id)
                        self.updateNameUser(response.body.data.attributes.email)
                        self.updateEmailUser(response.body.data.attributes.email)
                        self.updateUserType("Admin");
                        self.updateIsLogin(true);
                        // self.$router.push({name: 'summary'});
                        self.findBookingsLocation()
                        // self.$router.push({name: 'dashboard_accesses'});
                        self.$router.push({name: 'main_menu_page'});


                  }else if(response.body.data.attributes.user_info_type=="booking_office"){
                    if(this.counter==''){
                      alert("Ingrese desde el aplicativo de escritorio")
                      this.user.email=''
                      this.user.password=''
                    }else if(this.counter!='counterOffline'){
                      self.updateAlertMessage("Esta intentando acceder con credenciales de otro tipo de counter")
                      self.updateIsInAlert(true)
                    }else{
                      if(!window.eel){
                        try {
                          let fs=window.require("fs")
                          if (fs) {
                            self.updateUserToken(response.body.meta.authentication_token)
                            self.updateUserId(response.body.data.id)
                            await self.downloadOfflineData(null)
                            self.updateNameUser("")
                            self.updateEmailUser(response.body.data.attributes.email)
                            self.updateUserType("Booking_office");
                            self.updateIsLogin(true);
                            self.$router.push({name: 'booking_office'})
                          }else{
                            self.updateAlertMessage("Ingrese desde el aplicativo ejecutando el programa como administrador")
                            self.updateIsInAlert(true)
                          }
                        } catch (error) {
                          self.updateAlertMessage("Ingrese desde el aplicativo ejecutando el programa como administrador")
                          self.updateIsInAlert(true)
                        }
                      }else{
                        self.updateUserToken(response.body.meta.authentication_token);
                        self.updateUserId(response.body.data.id);
                        await self.downloadOfflineData(null);
                        self.updateNameUser("");
                        self.updateEmailUser(response.body.data.attributes.email);
                        self.updateUserType("Booking_office");
                        self.updateIsLogin(true);
                        self.$router.push({name: 'booking_office'});
                      }
                    }
                  }else if(response.body.data.attributes.user_info_type=="Counter" ){
                    if(self.isDesktopApp){
                      if(this.counter!='counterAccess'){
                        self.updateAlertMessage("Esta intentando acceder con credenciales de otro tipo de counter")
                        self.updateIsInAlert(true)
                      }else{
                        // self.loadingMessage="Verificando compatibilidad con Huella"
                        // var verified= await self.verifyLoadedData()
                        // if(verified){
                          self.updateUserToken(response.body.meta.authentication_token)
                          self.updateUserId(response.body.data.id)
                          self.updateEmailUser(response.body.data.attributes.email)
                          self.updateUserType("Counter");
                          let myLocation=response.body.data.attributes.counter_location
                          localStorage.setItem("location_id",myLocation.id)
                          localStorage.setItem("location_name",myLocation.name)
                          // self.loadingMessage="Obteniendo respuesta del servidor..."
                          // await self.downloadOfflineData(myLocation.id)
                          // self.loadingMessage=""
                          self.updateIsLogin(true);
                          self.$router.push({name: 'location_access', params: {id: myLocation.id, filter:false,date: new Date().toISOString().substr(0, 10),date2:new Date().toISOString().substr(0, 10),namex:myLocation.name}})
                        // }else{
                        //   self.updateAlertMessage('Hay un error con los archivos para la huella, por favor instale primero el aplicativo')
                        //   self.updateIsInAlert(true)
                        // }
                      }
                  }else{
                  self.updateUserToken(response.body.meta.authentication_token)
                  self.updateUserId(response.body.data.id)
                  self.updateEmailUser(response.body.data.attributes.email)
                  self.updateUserType("Counter");
                  const myLocation = response.body.data.attributes.counter_location
                  if (myLocation && myLocation.id != null) {
                    localStorage.setItem('location_id', String(myLocation.id))
                    if (myLocation.name != null) localStorage.setItem('location_name', myLocation.name)
                  }
                  self.updateIsLogin(true);
                  self.$router.push({ name: 'main_menu_page' });
                } 
                  }else if(response.body.data.attributes.user_info_type=="AgreementAdminUser"){
                    self.updateUserToken(response.body.meta.authentication_token)
                    self.updateUserId(response.body.data.id)
                    self.updateEmailUser(response.body.data.attributes.email)
                    self.updateIsLogin(true);
                    self.updateUserType("AgreementAdminUser");
                    self.$router.push({name: 'agreement_invitations_index', params: {id: self.getUserId()}})

                  }else{
                    if(self.isDesktopApp){
                      self.updateAlertMessage("No estás autorizado para acceder a esta página")
                      self.updateIsInAlert(true)
                    }else{
                      // alert("No estás autorizado para acceder a esta página")
                      self.updateAlertMessage("No estás autorizado para acceder a esta página");
                      self.updateIsInAlert(true);
                    }
                    self.user.email=''
                    self.user.password=''
                  }

              }
              console.log("------------------ Company Updated");
              console.log(this.getCompany());

              }, function(response){
                self.loading = false
                if(response.status==0){
                  this.isOnLine = false;
                  this.offlineSignIn();
                  return;
                }
                var err = response.body && response.body.errors && response.body.errors[0];
                var details = err && err.details;
                var text = "";
                if(details != null && details !== ""){
                  if(Array.isArray(details)){
                    text = details.join(" ");
                  }else if(typeof details === "object"){
                    var message = [];
                    for(var key in details){
                      message.push(details[key]);
                    }
                    text = message.join(" ");
                  }else{
                    text = String(details);
                  }
                }
                if(!text && err && err.title){
                  text = err.title;
                }
                if(!text){
                  text = "No se pudo iniciar sesión";
                }
                self.updateAlertMessage(text);
                self.updateIsInAlert(true);
                self.user.password=''
              });
            }else{
              if(self.isDesktopApp){
              self.updateAlertMessage('Por favor ingrese usuario y contraseña')
              self.updateIsInAlert(true)
              }else{
                if(this.user.password == ""){
                  this.error_pass = 'Por favor ingrese la contraseña';
                }
                if(this.user.email == ""){
                  this.error_email = 'Por favor ingrese el usuario';
                }
              }
            }
          }else if(this.user.email != "" && this.user.password != "" && this.ipCounterTaquilla != ""){
            const controller = new AbortController()
            // 5 second timeout:
            const timeoutId = setTimeout(() => {
                controller.abort();
                this.updateAlertMessage("Error de conexión con la ip: verifica tu conexion a red local, que estes a la misma red y que hallan iniciado sesion correctamente en el Counter Offline");
                this.updateIsInAlert(true);
                this.ipCounterTaquilla="";
              }, 2500)
            let counterPort = 8081;
            if (window.eel) {
              counterPort = await window.eel.eel_get_config_port()();
            }
            fetch(`http://${this.ipCounterTaquilla.replace(/ /g,"")}:${counterPort}/api_authentication`,
              {
                signal: controller.signal,
                method: 'POST',
                mode: 'cors',
                body:JSON.stringify({credentials: btoa(JSON.stringify(this.user))}),
                headers: {
                  "Content-Type": "application/json"
                }
              })
              .then(response => response.json())
              .then(data =>{
                clearTimeout(timeoutId);
                if(data.status=="422"){
                  this.updateAlertMessage(data.error_message);
                  this.updateIsInAlert(true);
                  this.user.email=""
                  this.user.password=""
                }else if(data.status=="201"){
                  this.updateUserToken(data.authorization_token);
                  this.updateUserId(this.user.email);
                  this.updateEmailUser(this.ipCounterTaquilla.replace(/ /g,""));
                  this.updateIsLogin(true);
                  this.updateUserType("CounterPrinter");
                  this.updateNameUser("Counter de Impresion");
                  this.$router.push({name: 'counter_printer'});
                }
                })
              .catch(error=>{
                console.log(error)
                clearTimeout(timeoutId)
                this.updateAlertMessage("Error de conexión con la ip: verifica tu conexion a red local, que estes a la misma red y que hallan iniciado sesion correctamente en el Counter Offline");
                this.updateIsInAlert(true);
                this.ipCounterTaquilla="";
                });
          }else{
            this.updateAlertMessage('Por favor ingrese la ip del counter, el usuario y la contraseña')
            this.updateIsInAlert(true)
          }
        }catch(e){
          this.loading = false
          alert(e.message);
        }
      },
      async offlineSignIn(){
        if(this.isDesktopApp){
          if(!window.eel){
            let fs=window.require("fs");

            if(await this.verifyLoadedData()){
              if(this.user.email != "" && this.user.password != ""){
                var aproved=await this.review_counter_user(this.user)
                if(aproved){
                  this.updateUserToken(null)
                  this.updateUserId(this.user.email)
                  this.updateUserType("Counter_offline");
                  this.updateIsLogin(true);
                  this.$router.push({name: 'offline_users'})
                }else{
                  this.updateAlertMessage("Correo o contraseña incorrecta")
                  this.updateIsInAlert(true)
                }
              }else{
                this.updateAlertMessage('Por favor complete los campos')
                this.updateIsInAlert(true)
              }
            }else if (fs.existsSync(`${window.__dirname}/../../db/lastLog.txt`)){
              let payload = {attributes: this.user};
              let text=this.encrypt(payload).toString();
              let access = await fs.readFileSync(
                `${window.__dirname}/../../db/lastLog.txt`,
                "utf-8"
              );
              if(text==access.split("\n")[0]){
                this.updateNameUser("Offline Counter")
                this.updateEmailUser(this.user.email)
                this.updateUserId(access.split("\n")[1])
                this.updateUserType("Booking_office");
                this.updateIsLogin(true);
                this.$router.push({name: 'booking_office'});
              }else{
                this.updateAlertMessage("Estas offline, ingresa con el ultimo usuario de taquilla que usaste")
                this.updateIsInAlert(true)
                this.user.email=''
                this.user.password=''
              }
            }else{
              this.updateAlertMessage('Hay un error con los archivos para la huella, por favor instale primero el aplicativo')
              this.updateIsInAlert(true)
            }
          }else{
            let offline_login = await window.eel.eel_offline_login({attributes: this.user})();
            if(offline_login){
              this.updateNameUser("Offline Counter")
              this.updateEmailUser(this.user.email)
              this.updateUserId(offline_login)
              this.updateUserType("Booking_office");
              this.updateIsLogin(true);
              this.$router.push({name: 'booking_office'});
            }else{
              this.updateAlertMessage("Estas offline, ingresa con el ultimo usuario de taquilla que usaste")
              this.updateIsInAlert(true)
              this.user.email=''
              this.user.password=''
            }

          }
        }else{
          this.updateAlertMessage('No hay internet para la descarga, puede ingresar con Desktop App Counter')
          this.updateIsInAlert(true)
        }
      },
      async downloadOfflineData(counter_location){
        // El API get_offline_info fue removido: ya no hay paquete offline masivo desde servidor.
        if(counter_location){
          return Promise.resolve();
        }else{
          let payload = {attributes: this.user};
          let text=this.encrypt(payload).toString()+"\n"+this.getUserId();
          if(!window.eel){
            let fs=window.require("fs");
            if (!fs.existsSync(`${window.__dirname}/../../db`)) {
              await fs.mkdirSync(`${window.__dirname}/../../db`);
            }
            if (!fs.existsSync(`${window.__dirname}/../../db/lastLog.txt`)) {
              //if file not exists
              fs.readFileSync(
                `${window.__dirname}/../../db/lastLog.txt`,
                { encoding: "utf-8", flag: "w+" }
              );
            }
            let response=await this.$http
              .get("app/scan_devices/find_ip_devices", {
                headers: {
                  "X-Device-ID": this.getDeviceId(),
                  Authorization: "Bearer " + this.getUserToken()
                },
                params: {
                  id: this.getUserId()
                }
              })
            text += "\n" +  `${response.body.data.location.invitations_max_uses},${response.body.data.location.create_access_ticket ? 1 : 0}` + "\n" + response.body.data.scanners.join(";");
            await fs.writeFileSync(
              `${window.__dirname}/../../db/lastLog.txt`,
              text
            );
          }else{
            window.eel.eel_save_login(payload);

          }
        }
      },
      downloadDesktopApp() {
        var myUrl="https://counter-sportlife-desktop.s3-us-west-2.amazonaws.com/SportlifeCounterDesktop.zip"
        window.location.href=myUrl;
        alert("Descargando Counter Desktop... \nHaga click para continuar")
      },

   async loadCompany(id,email){
      var self=this;
      return new Promise(function(resolve, reject) {

        try {

          self.$http.get("companies/"+id)
          .then((response) =>{
            self.updateCompanyLoaded(false)
            const dataCompany = response.body.data.attributes
            console.log('company-',response.body.data.attributes)

            if(dataCompany.locations_sublocations == null){
              self.sublocations = {
                    time_out: false,
                    bookings: false
                  }
            }else{
              self.sublocations = {
                    time_out: dataCompany.locations_sublocations.time_out == null ? dataCompany.locations_sublocations.time_out : '',
                    bookings: dataCompany.locations_sublocations.bookings == null ? dataCompany.locations_sublocations.bookings : ''
                  }
            }
            if(dataCompany.personalize_colors == null){
                  self.colors = {
                    principal: '#0076FF',
                    secundary: '#09CA6C'
                  }        }else{
                  self.colors = {
                    principal: dataCompany.personalize_colors.principal,
                    secundary: dataCompany.personalize_colors.secundary
                  }
            }

            console.log('*********dataCompany.access_virtual*****', dataCompany.access_virtual_guard)

          var company =  {
              id:response.body.data.id,
              user_name: '',
              description:dataCompany.description != null ? dataCompany.description : '',
              document_number: "",
              email: email,
              company_name: dataCompany.name,
              address: dataCompany.address != null ? dataCompany.address : '',
              identify_number: dataCompany.identify_number,
              photo_link_enabled: dataCompany.photo_link_enabled,
              max_time_exceeded_blocking: dataCompany.max_time_exceeded_blocking != null ? dataCompany.max_time_exceeded_blocking : false,
              directory: dataCompany.client_information_directory,
              dashboard:{
                users: dataCompany.dashboard_users,
                offers: dataCompany.dashboard_offers,
                rewards: dataCompany.dashboard_rewards,
                access: dataCompany.dashboard_access
              },
              offers:{
                redemption_form: dataCompany.offers_redemption_form != null ? dataCompany.offers_redemption_form : '',
                favorites: dataCompany.offers_favorites
              },
              rewards:{
                user_characteristics: dataCompany.rewards_user_characteristics,
                segments: dataCompany.rewards_segments,
                rewards: dataCompany.rewards_rewards
              },
              access:{
                general_access: dataCompany.access_general_access != null ? dataCompany.access_general_access : false,
                without_internet_access: dataCompany.access_without_internet_access,
                keyboard_access: dataCompany.access_keyboard_access,
                dynamic_invitations: dataCompany.access_dynamic_invitations,
                room_bookings: dataCompany.access_room_bookings != null ? dataCompany.access_room_bookings : false,
                courtesies: dataCompany.access_courtesies,
                covenants: dataCompany.access_covenants,
                reports: dataCompany.access_reports,
                alerts: dataCompany.access_alerts,
                counter: dataCompany.access_counter,
                user_access:dataCompany.access_user_access,
                virtual_guard: dataCompany.access_virtual_guard,
                notify_access: dataCompany.access_notify_access,
                device_administration: dataCompany.access_device_administration,
                remote_open_door: dataCompany.access_remote_open_door,
                invitation_approved: dataCompany.access_invitation_approved
              },
              locations:{
                offers_and_rewards: dataCompany.location_offers_and_rewards,
                sublocations:self.sublocations,
                holidays: dataCompany.locations_holidays,
                associated_locations: dataCompany.locations_associated_locations
              },
              personal_trainer:{
                personal_trainer: dataCompany.personal_trainer_classes
              },
              messages:{
                notifications: dataCompany.messages_notifications,
                segment_mails: dataCompany.messages_segment_mails,
                massive_messages: dataCompany.messages_massive_messages
              },
              news:{
                general_news: dataCompany.news_general_news,
                video_news: dataCompany.news_video_news,
                twits_news: dataCompany.news_twits_news
              },
              events:{
                tickets: dataCompany.events_tickets
              },
              company_connections:{
                company_connections: dataCompany.company_connections_company_connections
              },
              client_information: {
                us: dataCompany.client_information_us,
                contact_us: dataCompany.client_information_contact_us
              },
              personalize:{
                web_page: dataCompany.personalize_web_page,
                mobile_app: dataCompany.personalize_mobile_app,
                colors: self.colors,
                app_logo: dataCompany.logo,
                principal_sections: dataCompany.personalize_principal_sections,
                secondary_sections: dataCompany.personalize_secundary_sections,
                personalize_mails: dataCompany.personalize_personalize_mails
              },
              inside_request:{
                payment_certificate: dataCompany.inside_request_payment_certificate,
                work_certificate: dataCompany.inside_request_work_certificate,
                contribution_certificate: dataCompany.inside_request_contribution_certificate
              },
              api_connections:{
                crm: dataCompany.api_connections_crm,
                end_points: dataCompany.api_connections_end_points
              },
              custom_forms:{
                all_forms: dataCompany.custom_forms
              },
              payments:{
                admin_payments: dataCompany.payments_admin_payments
              },
              forms:{
                custom_forms: dataCompany.custom_forms
              },
              notifications:{
                push_notifications: dataCompany.notifications_push_notifications,
                whatsapp_messages: dataCompany.notifications_whatsapp_notifications
              },
              sgsst:{
                general: dataCompany.sgsst_general
              },
              alarms:{
                alarms: dataCompany.use_of_alarms
              },
              parcels: {
                parcels_delivery: dataCompany.parcel_delivery
              },
              invitations:{
                admin_invitations: dataCompany.invitations_admin_invitations
              },
              access_invitation_approved: dataCompany.access_invitation_approved
            }
          console.log('****load company****',company)
          self.updateCompany(company)
          self.updateCompanyLoaded(true)

          resolve();

          })

          } catch (e) {
              reject(e)
              alert(e.message)
            }

        });

      }
    },
    created(){
      if(this.isDesktopApp){
        if(!localStorage.getItem("fingerprint_API_env")){
          localStorage.setItem("fingerprint_API_env", window.process.env.APPDATA+"/Service_Fingerprint/")
        }
      }
      this.isOnLine=navigator.onLine
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/views/LogIn.vue